import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const FaithLearning = () => {
 return (
 <div className="faith-learning-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">Personal Faith & Worldview Learning</h1>
 <p className="page-subtitle">
 Respecting individual belief and family choice.
 </p>
 </div>
 </section>

 <section className="position-section">
 <div className="section-container">
 <h2 className="section-title">Our Position</h2>
 <div className="position-content">
 <Card className="position-card">
 <CardContent className="position-card-content">
 <p>
 Nova Roots welcomes children and families from all backgrounds.
 </p>
 <p>
 We recognise that faith, belief and worldview are deeply personal journeys. 
 As a school, we do not promote a single religion or belief system. We respect 
 each family's right to guide this aspect of their child's development.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="optional-section">
 <div className="section-container">
 <h2 className="section-title">Optional Faith-Based Study</h2>
 <div className="optional-content">
 <p className="optional-intro">
 Families may choose for their child to engage in optional, faith-aligned study 
 alongside their core learning.
 </p>
 <Card className="optional-card">
 <CardContent className="optional-card-content">
 <p className="optional-subtitle">This may include:</p>
 <ul className="faith-options-list">
 <li>Christian Bible study</li>
 <li>Islamic studies</li>
 <li>Other faith or worldview-based learning, where appropriate</li>
 </ul>
 <p className="optional-note">
 Participation is always optional and led by family choice.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="how-it-works-section">
 <div className="section-container">
 <h2 className="section-title">How Faith Learning Works</h2>
 <div className="how-content">
 <Card className="how-card">
 <CardContent className="how-card-content">
 <p>
 Faith-based study is supported through personalised, AI-assisted learning 
 pathways, rather than whole-class instruction.
 </p>
 </CardContent>
 </Card>
 
 <div className="ensures-grid">
 <p className="ensures-intro"><strong>This approach ensures:</strong></p>
 <div className="ensures-items">
 <div className="ensure-item">
 <div className="ensure-circle"></div>
 <p>Respect for individual belief systems</p>
 </div>
 <div className="ensure-item">
 <div className="ensure-circle"></div>
 <p>No hierarchy between religions</p>
 </div>
 <div className="ensure-item">
 <div className="ensure-circle"></div>
 <p>No proselytising in shared learning spaces</p>
 </div>
 <div className="ensure-item">
 <div className="ensure-circle"></div>
 <p>No pressure on children or families</p>
 </div>
 </div>
 </div>

 <Card className="formation-card">
 <CardContent className="formation-card-content">
 <p>
 Faith learning is treated as personal formation, not institutional doctrine.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="school-role-section">
 <div className="section-container">
 <h2 className="section-title">The School's Role</h2>
 <div className="role-content">
 <Card className="role-statement-card">
 <CardContent className="role-statement-content">
 <h3>Nova Roots does not teach religion.</h3>
 </CardContent>
 </Card>

 <div className="responsibility-content">
 <p className="responsibility-intro">The school's responsibility is to:</p>
 <div className="responsibility-grid">
 <Card className="responsibility-card">
 <CardContent className="responsibility-item">
 <p>Create an inclusive environment</p>
 </CardContent>
 </Card>
 <Card className="responsibility-card">
 <CardContent className="responsibility-item">
 <p>Protect freedom of belief and non-belief</p>
 </CardContent>
 </Card>
 <Card className="responsibility-card">
 <CardContent className="responsibility-item">
 <p>Ensure shared spaces remain respectful and neutral</p>
 </CardContent>
 </Card>
 <Card className="responsibility-card">
 <CardContent className="responsibility-item">
 <p>Ground community life in shared human values</p>
 </CardContent>
 </Card>
 </div>
 </div>

 <Card className="ethics-card">
 <CardContent className="ethics-content">
 <p>
 Ethics and character are approached through universal principles such as 
 dignity, responsibility, honesty and care.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>
 </div>
 );
};

export default FaithLearning;
